import axios from "axios";
import { currentEnvironment } from "../utils/environment";
import { Period } from "../utils/period";
import { baseAPI } from "../utils/apiStrings";

const devEnvironment = currentEnvironment();

const APP_KEY = devEnvironment
  ? process.env.REACT_APP_CRM_APP_KEY
  : process.env.REACT_APP_CRM_APP_KEY_LIVE;
const AUTH = devEnvironment
  ? process.env.REACT_APP_CRM_AUTHORIZATION
  : process.env.REACT_APP_CRM_AUTHORIZATION_LIVE;

// const baseURL =
//   process.env.REACT_APP_ENVIRONMENT === "production"
//     ? "https://store.lawpavilion.com/api"
//     : "https://store-staging.lawpavilion.com/api";

export default class State {
  static fetchAllStates = async () => {
    try {
      const response = await axios.get(`${baseAPI()}/states`);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  static findStateLaws = async (stateId) => {
    const { data } = await axios.get(
      `${baseAPI()}/states/${stateId}?with_laws=1`,
    );
    return data;
  };

  static fetchStateLaws = async (stateId) => {
    try {
      const response = await axios.get(
        `${baseAPI()}/states/${stateId}?with_laws=1`,
      );

      const { laws, name } = response.data.data;

      return { laws, name };
    } catch (error) { }
  };

  static getAnnualSub = async (period) => {
    try {
      const response = await axios.get(
        `https://crm${devEnvironment ? "-staging" : ""
        }.lawpavilion.com/api/v2/transactions/lagos-state-laws?APP_KEY=${APP_KEY}&period=${period}`,
        {
          headers: {
            "Content-type": "application/.json",
            Authorization: AUTH,
          },
        },
      );

      return response.data.data;
    } catch (error) {
      return error;
    }
  };

  static fetchAddonSales = async (
    sessionToken,
    stateID,
    fromDate = "",
    toDate = "",
    period = "",
  ) => {
    try {
      const response = await axios.get(
        `${baseAPI()}/state-law-addon/${stateID}/sales?from_date=${fromDate}&to_date=${toDate}&period=${period}`,
        {
          headers: { Authorization: "Bearer " + sessionToken },
        },
      );

      return response.data.data;
    } catch (error) {
      return error;
    }
  };

  static filterAnnualSub = async (startDate, endDate) => {
    const start = Period.setDateFormat(startDate);
    const end = Period.setDateFormat(endDate);

    try {
      const response = await axios.get(
        `https://crm${devEnvironment ? "-staging" : ""
        }.lawpavilion.com/api/v2/transactions/lagos-state-laws?APP_KEY=${APP_KEY}&start_date=${start}&end_date=${end}`,
        {
          headers: {
            "Content-type": "application/.json",
            Authorization: AUTH,
          },
        },
      );

      return response.data.data;
    } catch (error) {
      return error;
    }
  };

  static getIndividualSales = async (token, period) => {
    try {
      const response = await axios.get(
        `${baseAPI()}/state-law/all-sales?period=${period}`,
        { headers: { Authorization: "Bearer " + token } },
      );

      const {
        total_outright_sales: outright,
        total_non_outright_sales: nonOutright,
      } = response.data.data;

      return { outright, nonOutright };
    } catch (error) {
      return error;
    }
  };

  static filterIndividualSales = async (token, startDate, endDate) => {
    const start = Period.setDateFormat(startDate);
    const end = Period.setDateFormat(endDate);

    try {
      const response = await axios.get(
        `${baseAPI()}/state-law/all-sales/filter?from_date=${start}&to_date=${end}`,
        { headers: { Authorization: "Bearer " + token } },
      );

      const {
        total_outright_sales: outright,
        total_non_outright_sales: nonOutright,
      } = response.data.data;

      return { outright, nonOutright };
    } catch (error) {
      return error;
    }
  };

  static getDashboardStats = async (token, stateId, start = "", end = "") => {
    try {
      const response = await axios.get(
        `${baseAPI()}/state-law/${stateId}/dashboard-statistics?from_date=${start}&to_date=${end}`,
        { headers: { Authorization: "Bearer " + token } },
      );

      return response.data.data;
    } catch (error) {
      return error;
    }
  };
}
